module.exports = __webpack_public_path__ + "img/LH_Nombre_Morado.d98a20b4.png";